import { render } from "./RegistryCard.vue?vue&type=template&id=69a25f3a&scoped=true"
import script from "./RegistryCard.vue?vue&type=script&lang=js"
export * from "./RegistryCard.vue?vue&type=script&lang=js"

import "./RegistryCard.vue?vue&type=style&index=0&id=69a25f3a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a25f3a"]])

export default __exports__